import {
  IReportDownloadListRequest,
  IReportGenerateRequest
} from '@module-report/models/report-download.interface';

export class GetReportDownloadList {
  static readonly type = '[ Report ] Get report download list';

  constructor(public params: IReportDownloadListRequest) {}
}

export class DownloadReport {
  static readonly type = '[ Report ] Download report';

  constructor(public reportId: string) {}
}

export class GenerateReport {
  static readonly type = '[ Report ] Generate report download';

  constructor(public params: IReportGenerateRequest) {}
}
